import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-organic-source',
  templateUrl: './help-add-organic-source.component.html',
  styleUrls: ['./help-add-organic-source.component.scss']
})
export class HelpAddOrganicSourceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
